import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gold-standard',
  templateUrl: './gold-standard.component.html',
  styleUrls: ['./gold-standard.component.css']
})
export class GoldStandardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
